var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest';
import { brandEndpointIds } from 'root/src/shared/brand/brand.constants';
import brandSettingsSelector from 'root/src/client/logic/form/selectors/brandSettingsSelector';
import { useAppDispatch, useAppSelector } from 'root/src/client/logic/helpers/useStore';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { usePublisherSettingsForm, buildBrandSettingsPayload, PublisherSettingsFields, } from 'root/src/client/v2/profile/features/ProfileSettingsDialog/publisherSettingsForm';
import { useSettingsDialogClose } from './SettingsDialogRow';
export const PublisherSettingsSection = () => {
    var _a;
    const dispatch = useAppDispatch();
    const closeDialog = useSettingsDialogClose();
    const current = useAppSelector(brandSettingsSelector);
    const [saved, setSaved] = useState(false);
    const [failed, setFailed] = useState(false);
    const { register, handleSubmit, setValue, watch, formState: { errors, isSubmitting } } = usePublisherSettingsForm(current);
    const brandLogoUrl = (_a = watch('brandLogoUrl')) !== null && _a !== void 0 ? _a : '';
    const onSubmit = handleSubmit((values) => __awaiter(void 0, void 0, void 0, function* () {
        setFailed(false);
        const payload = buildBrandSettingsPayload(values);
        const toastId = toast.loading('Saving publisher settings...');
        try {
            const result = yield dispatch(apiRequest(brandEndpointIds.SET_BRAND_SETTINGS, payload));
            if (result === null || result === void 0 ? void 0 : result.error) {
                throw result.error;
            }
            setSaved(true);
            closeDialog();
            // Fire the confirmation just after the dialog closes (0.15s close animation) so the toast
            // lives on the page instead of being torn down together with the closing dialog layer.
            setTimeout(() => toast.success('Publisher settings saved', { id: toastId }), 200);
        }
        catch (e) {
            setFailed(true);
            setTimeout(() => setFailed(false), 1300);
            toast.error('Could not save publisher settings', { id: toastId, description: 'Please try again.' });
        }
    }), () => {
        toast.error('Check the form', { description: 'Fix the highlighted fields.' });
    });
    return (<div>
			<h3 className="mb-1 text-sm font-semibold">Publisher Settings</h3>
			<p className="mb-4 text-xs text-muted-foreground">Your public brand profile shown across DareDrop.</p>
			<form id="publisher-settings-form" onSubmit={onSubmit} className="space-y-3">
				<PublisherSettingsFields register={register} errors={errors} brandLogoUrl={brandLogoUrl} onLogoUploaded={url => setValue('brandLogoUrl', url, { shouldDirty: true, shouldValidate: true })}/>
			</form>
			<div className="mt-5 flex justify-end">
				<Button type="submit" form="publisher-settings-form" size="sm" variant="brand" loading={isSubmitting} success={saved} error={failed} className="h-9 min-w-[110px] rounded-lg text-xs">
					Save
				</Button>
			</div>
		</div>);
};
